var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"surveys-tour"},[(_vm.showTour)?_c('div',{staticClass:"tour-overlay"}):_vm._e(),_c('v-tour',{attrs:{"name":"myTour","steps":_vm.tourSteps,"callbacks":_vm.tourCallbacks}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }